
<div class="d-flex justify-content-center loader flex-column align-items-center" *ngIf="loading || !parents">
    <div>
      <mat-spinner color="accent"></mat-spinner>
    </div>
  </div>

  <mat-toolbar class="d-flex justify-content-between">
    <mat-card-title>Businesses</mat-card-title>
    <div class="spacer"></div>
    <div *ngIf="search && (search?.name !== '')" class="d-flex">Results for <span class="ml-2 mr-3 text-primary">{{search?.name}} {{search?.mobile}} {{search?.email}}</span> 
    </div>
    <div class="spacer"></div>
    <button class="mr-2" disabled="true" mat-mini-fab color="primary" aria-label="Save Profiles" (click)="saveProfiles()">
      <fa-icon class="text-white" [icon]="faSave"></fa-icon> 
  </button>
    <button class="mr-2" mat-mini-fab color="primary" aria-label="Clear Search" (click)="reloadParents()">
        <fa-icon class="text-white" [icon]="faUndo"></fa-icon> 
    </button>
    <button class="mr-2"  mat-mini-fab color="primary" aria-label="Create Business" (click)="createBusiness()">
      <fa-icon [icon]="faPlus" class="text-white"></fa-icon> 
    </button>
    <button *ngIf="!search || (search?.name === '')" mat-mini-fab color="primary" aria-label="Search Business" (click)="openSideNav(sideNavActions.SearchBusiness)">
        <fa-icon class="text-white" [icon]="faSearch"></fa-icon> 
    </button>
    <button *ngIf="search && (search?.name !== '')" mat-stroked-button (click)="openSideNav(sideNavActions.SearchBusiness)">
      <fa-layers size="2x">
        <fa-icon class="link" [icon]="faSearch"></fa-icon>
        <fa-layers-counter [content]="'X'"></fa-layers-counter>
      </fa-layers>
    </button>

  </mat-toolbar>
  <div class="p-2 h-100 w-100 relative scrollable pb-5">
  <table *ngIf="dataSource?.data" mat-table [dataSource]="dataSource" class="mat-elevation-z8">
    <ng-container matColumnDef="Name">
      <th mat-header-cell *matHeaderCellDef class="parent-col"> Name </th>
      <td mat-cell *matCellDef="let element">
        <div class="d-flex align-items-center ">
          <div>
            <div class="initials">{{element.Name ? element.Name[0] : ''}}</div>
          </div>
          <div>
            <p class="ml-2 m-0">{{element.Name}}</p>
          </div>
        </div>
      </td>
    </ng-container>

        <ng-container matColumnDef="Address">
          <th mat-header-cell *matHeaderCellDef> Address </th>
          <td mat-cell *matCellDef="let element"> {{element.Address}} </td>
        </ng-container>
        <ng-container matColumnDef="Category">
          <th mat-header-cell *matHeaderCellDef> Category </th>
          <td mat-cell *matCellDef="let element"> {{element.Category?.get('name')}} </td>
        </ng-container>
        <ng-container matColumnDef="Mobile">
          <th mat-header-cell *matHeaderCellDef> Mobile </th>
          <td mat-cell *matCellDef="let element"> {{element.Mobile}} </td>
        </ng-container>
        <ng-container matColumnDef="Email">
          <th mat-header-cell *matHeaderCellDef> Email </th>
          <td mat-cell *matCellDef="let element"> {{element.Email}} </td>
        </ng-container>
        <ng-container matColumnDef="Actions">
          <th mat-header-cell *matHeaderCellDef>Actions</th>
  
          <td [ngClass]="'text-center'" mat-cell *matCellDef="let element">
            <div class="d-flex flex-row">
              <p class="d-sm-none me-2"><b>View:</b></p>
              <button
                (click)="openParent(element)"
                title="view"
                type="button"
                class="btn btn-outline-primary btn_yellow_mobile btn_yellow"
              >
              Open
              </button>
            </div>
          </td>
        </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
  <mat-paginator #parentsPaginator
          *ngIf="dataSource?.data"
          [length]="parentCount"
          [pageSize]="displayLimit"
          [pageIndex]="page"
          [pageSizeOptions]="[5, 10, 25, 100]"
          aria-label="Select page"
          (page)="pageParents($event)">
  </mat-paginator>

</div>